import { Injectable } from "@angular/core";
// import { AngularFireAuth } from "angularfire2/auth";
// import * as firebase from 'firebase/app';
@Injectable()
export class AuthorizationService {

    constructor(
        // public afAuth: AngularFireAuth
        ){
    }

    login(){
       return null
       // this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
    }
}


// WEBPACK FOOTER //
// /home/xpro/Documentos/ances/myjangular/src/app/layout/service/authorization.service.ts